module.exports = __webpack_public_path__ + "static/media/circleCross.ec42d734.svg";